export default __webpack_public_path__ + "static/media/thumbnail.273859fe.png";